import React from 'react';
import Table from './Table'
import Loading from './Loading'
import {Requestdynamic} from '../../Network/Fetch';
import PopUp from './PopUp'
import PopUpDelete from './PopUpDelete'
import Cookies from 'universal-cookie'
import Header from './Header'
import ExcelFile from './ExportExcelFile'

class DeletedMember extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        member: [],
        memberDisplay: [],
        searchMember: [],
        searchMemberRegistration: [],
        loadingMore: false,
        openModal: false,
        openModalDelete: false,
        transfertStatus: null,
        title: null,
        message: null,
        search: null,
        infoMemberTransfert: null,
        Filter: [],
        FilterRegistration: [],
        searchRegistration: false,
        sortFilter: {
          FirstName: "up",
          LastName: "up",
          Email: 'up',
          Society: "up",
          AccountCreatedAt: "up",
          SubscriptionBegin: "up",
          DeletedAt: "up",
          RegistrationType: "up",
          Region: "up",
        }
      }
    }


    _sortByAlphabet = (Name) => {
      var Verify = ""
      if (this.state.searchRegistration === true)
        Verify = "searchMemberRegistration"
      else
        Verify = "member"

      var Copy = [...this.state[Verify]];
      var NameSortFilter = this.state.sortFilter[Name]
      var SortedResult = Copy.sort(function(a, b){
        var nameA, nameB
        if (!a[Name])
          a[Name] = ""
        if (!b[Name])
          b[Name] = ""
         nameA = a[Name].toLowerCase();
         nameB = b[Name].toLowerCase();
         if (nameA < nameB) //sort string ascending
          return -1;
       return 0; //default return value (no sorting)
        });
      if (NameSortFilter === 'down')
        SortedResult = SortedResult.reverse()
      var Display = SortedResult.slice(0, 20);
      var sortOrder = Object.assign({}, this.state.sortFilter)
      sortOrder[Name] = sortOrder[Name] === 'up' ? "down" : 'up'
      this.setState({memberDisplay: Display, member: SortedResult, sortFilter: sortOrder})
    }

    _closeDeleteToUser = async (Member) => {
      this.setState({openModalDelete: false, infoMemberTransfert: null, transfertStatus: null})
    }

    _transfertDeleteToMember = async (Member) => {
      this.setState({transfertStatus: "Waiting"}, async () => {
        var cookies = new Cookies();
        var Jwt = cookies.get('acces');
        var Params = {Jwt: Jwt, Id: this.state.infoMemberTransfert.Id}
        var promise = await Requestdynamic('_transfertDeleteToMember', Params)
        if (promise.error === false && promise.data.error === false){
          this.setState({transfertStatus: "Success"}, async () => {
            var Copy = [...this.state.member]
            var IndexCopy = Copy.findIndex(res => res.Id === this.state.infoMemberTransfert.Id)
            Copy.splice(IndexCopy, 1)
            var CopyDisplay = [...this.state.memberDisplay]
            var IndexCopyDisplay = CopyDisplay.findIndex(res => res.Id === this.state.infoMemberTransfert.Id)
            CopyDisplay.splice(IndexCopyDisplay, 1)
            await this.sleep(500)
            this.setState({transfertStatus: null, member: Copy, memberDisplay: CopyDisplay, openModalDelete: false, infoMemberTransfert: null})
          })
          return ;
        }
        else {
          if (promise.error === true)
            this.setState({transfertStatus: "Error"})
          else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true)
          {
            cookies = new Cookies();
            cookies.remove('acces', { path: '/' })
            cookies.remove('infoAdmin', { path: '/' })
            await this.sleep(900)
            var url = '/login'
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            return ;
          }
          else
            this.setState({transfertStatus: "Error"})
        }
      })
    }

    _openDeleteToUser = async (Member) => {
      this.setState({openModalDelete: true, infoMemberTransfert: Member})
    }

    _getAllNextDeletedMember = async () => {
      this.setState({loadingMore: true, searchMemberRegistration: [], FilterRegistration: [], searchRegistration: false}, async() => {
        await this.sleep(150)
        var cookies = new Cookies();
        var Jwt = cookies.get('acces');
        var Params = {
            Jwt: Jwt,
        }
        if (this.state.Filter.length !== 0)
          Params.RegionFrontend = this.state.Filter
        var promise = await Requestdynamic('_getAllNextDeletedMember', Params)
        console.log(promise)
        if(promise.error === false && promise.data.error === false)
        {
          var MemberCopy = [...this.state.member];
          var newListMember = MemberCopy.concat(promise.data.data)
          newListMember = [...new Set(newListMember)]
          var MemberDisplay = newListMember.slice(0, 20)
          var paramsSetState = {memberDisplay: MemberDisplay, member: newListMember}
          this.setState(paramsSetState)
        }
        else {
          if (promise.error === true)
            this.setState({title: 'Error', openModal: true, message: "Un problème est survenue veuillez réesayer plus tard", LastKey: false, MemberDelete: null, statusDelete: null, delete: false})
          else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true){
            cookies = new Cookies();
            cookies.remove('acces', { path: '/' })
            cookies.remove('infoAdmin', { path: '/' })
            await this.sleep(900)
            var url = '/login'
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            return ;
          }
          else
            this.setState({title: 'Error', openModal: true, message: "Un problème est survenue veuillez réesayer plus tard", LastKey: false, MemberDelete: null, statusDelete: null, delete: false})
        }
        this.setState({loadingMore: false})
      })

    }

    _addAllNextMember = async () => {
      this.setState({loadingMore: true}, async() => {
        var Copy;
        if (this.state.search != null)
           Copy = [...this.state.searchMember]
        else if (this.state.searchRegistration === true)
          Copy = [...this.state.searchMemberRegistration]
        else
           Copy = [...this.state.member]

        var CopyDisplay = [...this.state.memberDisplay];

        var Length = Copy.length
        var LengthDisplay = CopyDisplay.length

        if (LengthDisplay >= Length)
        {
          this.setState({loadingMore: false})
          return ;
        }
        var CopySplice = Copy.slice(LengthDisplay, LengthDisplay + 20)
        var Display = CopyDisplay.concat(CopySplice)
        Display = [...new Set(Display)]
        this.setState({loadingMore: false, memberDisplay: Display})
        return ;
      })
    }

    componentDidMount(){
      this._getAllNextDeletedMember()
    }

     sleep = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    search = (value) => {
      var Copy, Display;
      var Verify;
      if (this.state.searchRegistration === true)
        Verify = "searchMemberRegistration"
      else
        Verify = "member"

      if (value.length === 0)
      {
         Copy = [...this.state[Verify]];
         Display = Copy.slice(0, 20)
        this.setState({search: null, memberDisplay: Display, searchMember: []})
        return ;
      }
       Copy = [...this.state[Verify]]
      var FilterResult = Copy.filter(res => {
        if (res.Email.toLowerCase().includes(value.toLowerCase()) || res.FirstName.toLowerCase().includes(value.toLowerCase()) || res.LastName.toLowerCase().includes(value.toLowerCase()))
          return true
        else if (res.Society && res.Society.toLowerCase().includes(value.toLowerCase()))
          return true
        return false
      })
       Display = FilterResult.slice(0, 20)
      this.setState({search: value, memberDisplay: Display, searchMember: FilterResult})
    }

    MemberDisplayRegistration = () => {
      var Copy, Display
      if (this.state.FilterRegistration.length === 0)
      {
         Copy = [...this.state.member];
         Display = Copy.slice(0, 20)
        this.setState({memberDisplay: Display, searchMemberRegistration: [], searchRegistration: false})
        return ;
      }
       Copy = [...this.state.member]
       var FilterResult = Copy.filter(res => this.state.FilterRegistration.find(registration => {
         if (registration === "Business")
           if (res.RegistrationType === "BusinessPackCustomize")
             return true
         if (registration === res.RegistrationType)
           return true
       }))
       Display = FilterResult.slice(0, 20)
      this.setState({searchRegistration: true, memberDisplay: Display, searchMemberRegistration: FilterResult})
    }

    handleScroll = (e) => {
      var verify;
      if (this.state.search === null && this.state.searchRegistration === false)
         verify = 'member'
      else if (this.state.search != null)
         verify = 'searchMember'
      else
        verify = 'searchMemberRegistration'

      const bottom = e.target.scrollHeight - e.target.scrollTop - 50 <= e.target.clientHeight;
      if (bottom && this.state.memberDisplay.length !== this.state[verify].length && this.state.loadingMore === false) {
        this._addAllNextMember()
      }
    }


 render() {

   return (
     <div style={{marginLeft: 10, overflowY: "auto"}} onScroll={this.handleScroll}>
     <PopUp openModal={this.state.openModal} message={this.state.message} title={this.state.title} refParent={this}/>
     <PopUpDelete transfert={this.state.transfertStatus} openModalDelete={this.state.openModalDelete} MemberTransert={this.state.infoMemberTransfert} message={this.state.message} title={this.state.title} refParent={this}/>
     <Header FilterRegistration={this.state.FilterRegistration} Member={this.state.member} searchRegistration={this.state.searchRegistration} searchMemberRegistration={this.state.searchMemberRegistration}  Filter={this.state.Filter} intl={this.props.intl} refParent={this}/>
     <ExcelFile data={this.state.member}/>
     <Table loadingMore={this.state.loadingMore} intl={this.props.intl} refParent={this} memberDisplay={this.state.memberDisplay} deleting={this.state.deleting} member={this.state.member}/>
     <Loading loadingMore={this.state.loadingMore}/>
    </div>
   )
 }
}


export default DeletedMember;
